
import { reactive, toRefs, toRaw, Ref } from 'vue';
import { AlbumEntry, SongEntry } from '../store/MusicStore';
import { currentlyPlayingStore } from '@/store';

export default {
  setup(props) {
    return {
      ...useSongSelector(props),
      formatDuration(duration: number) {
        if (duration > 3600) {
          const hours = Math.floor(duration / 3600);
          duration %= 3600;
          const minutes = Math.floor(duration / 60).toString().padStart(2, '0');
          const seconds = Math.floor(duration % 60).toString().padStart(2, '0');
          return `${hours}:${minutes}:${seconds}`;
        } else {
          const minutes = Math.floor(duration / 60);
          const seconds = Math.floor(duration % 60).toString().padStart(2, '0');
          return `${minutes}:${seconds}`;
        }
      }
    };
  },
  props: {
    album: {
      type: Object as () => AlbumEntry,
      required: true
    }
  }
};

function useSongSelector(props: { album: AlbumEntry }) {
  const state = reactive({
    currentSong: null as SongEntry
  });

  function selectSong(song: SongEntry) {
    console.log('Selected', song);
    state.currentSong = song;
    currentlyPlayingStore.setQueue(props.album.songs);
    currentlyPlayingStore.selectSong(song);
  }

  function isCurrentSong(song: SongEntry) {
    return toRaw(song) === toRaw(state.currentSong);
  }

  return {
    ...toRefs(state),
    isCurrentSong,
    selectSong
  };
}

